import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Navbar from '../components/Navbar';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

export default function PaymentSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [paymentData, setPaymentData] = useState(null);
  const [error, setError] = useState(null);
  const eventToken = searchParams.get('event_token');
  const returnPath = eventToken ? `/evento/${eventToken}/conferma` : '/dashboard';
  const returnLabel = eventToken ? 'Vai alla conferma iscrizione' : 'Torna alla Dashboard';

  useEffect(() => {
    const sessionId = searchParams.get('session_id');
    if (sessionId) {
      verifyPayment(sessionId);
    } else {
      setError('Session ID mancante');
      setVerifying(false);
    }
  }, [searchParams]);

  const verifyPayment = async (sessionId) => {
    try {
      const endpoint = eventToken
        ? `/public/activity/${eventToken}/payments/verify-session/${sessionId}`
        : `/payments/verify-session/${sessionId}`;
      const response = await axios.get(endpoint);
      setPaymentData(response.data);
    } catch (error) {
      console.error('Payment verification failed', error);
      const errorMsg = error.response?.data?.detail || 'Errore nella verifica del pagamento';
      setError(errorMsg);
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-20 p-6 max-w-4xl mx-auto">
        {verifying ? (
            <Card>
              <CardContent className="pt-6 text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                <p className="text-lg">Verifica pagamento in corso...</p>
              </CardContent>
            </Card>
          ) : error ? (
            <Card className="border-red-500">
              <CardContent className="pt-6 text-center">
                <div className="text-red-500 text-5xl mb-4">❌</div>
                <h2 className="text-2xl font-bold mb-2">Errore</h2>
                <p className="text-gray-600 mb-6">{error}</p>
                <Button onClick={() => navigate(returnPath)}>
                  {returnLabel}
                </Button>
              </CardContent>
            </Card>
          ) : paymentData && paymentData.payment_status === 'paid' ? (
            <Card className="border-green-500">
              <CardContent className="pt-6 text-center">
                <div className="text-green-500 text-5xl mb-4">✅</div>
                <h2 className="text-2xl font-bold mb-2">Pagamento Completato!</h2>
                <p className="text-gray-600 mb-4">
                  Il tuo pagamento di <strong>€{paymentData.amount.toFixed(2)}</strong> è stato elaborato con successo.
                </p>
                <p className="text-sm text-gray-500 mb-6">
                  Grazie per aver completato il pagamento. La tua iscrizione è stata confermata!
                </p>
                <Button onClick={() => navigate(returnPath)} className="bg-green-600 hover:bg-green-700">
                  {returnLabel}
                </Button>
              </CardContent>
            </Card>
          ) : (
            <Card className="border-yellow-500">
              <CardContent className="pt-6 text-center">
                <div className="text-yellow-500 text-5xl mb-4">⏳</div>
                <h2 className="text-2xl font-bold mb-2">Pagamento in Elaborazione</h2>
                <p className="text-gray-600 mb-6">
                  Il pagamento è ancora in elaborazione. Riceverai una conferma via email.
                </p>
                <Button onClick={() => navigate(returnPath)}>
                  {returnLabel}
                </Button>
              </CardContent>
            </Card>
          )}
      </div>
    </div>
  );
}
